exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-admin-index-js": () => import("./../../../src/pages/admin/index.js" /* webpackChunkName: "component---src-pages-admin-index-js" */),
  "component---src-pages-admin-signin-js": () => import("./../../../src/pages/admin/signin.js" /* webpackChunkName: "component---src-pages-admin-signin-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-cocktail-page-js": () => import("./../../../src/templates/CocktailPage.js" /* webpackChunkName: "component---src-templates-cocktail-page-js" */)
}

